import {NgModule} from "@angular/core";
import {CoreModule} from "../core/core.module";
import {TableModule} from "primeng/table";
import {CrossModule} from "../cross/cross.module";
import {InteractionComponent} from "./component/interaction/interaction.component";
import {InteractionTypesPage} from "./page/interaction-types/interaction-types.page";
import {InteractionPage} from "./page/interaction/interaction.page";
import {DataViewModule} from "primeng/dataview";
import {InteractionTypesComponent} from "./component/interaction-types/interaction-types.component";
import {DsModule} from "../ds/ds.module";
import {InteractionFormComponent} from "./component/interaction-form/interaction-form.component";
import {InteractionIntroComponent} from "./component/interaction-intro/interaction-intro.component";
import {InteractionScheduleComponent} from "./component/interaction-schedule/interaction-schedule.component";
import {InteractionFinalComponent} from "./component/interaction-final/interaction-final.component";
import {CarouselModule} from "primeng/carousel";
import {InteractionStepComponent} from "./component/interaction-step/interaction-step.component";
import {BrowserModule} from "@angular/platform-browser";
import {ProgressSpinnerModule} from "primeng/progressspinner";
import {ConfirmDialogModule} from "primeng/confirmdialog";


@NgModule({
  declarations: [
    InteractionComponent,
    InteractionTypesComponent,
    InteractionTypesPage,
    InteractionPage,
    InteractionFormComponent,
    InteractionIntroComponent,
    InteractionScheduleComponent,
    InteractionFinalComponent,
    InteractionStepComponent,
  ],
  exports:[
    InteractionComponent,
    InteractionTypesComponent,
    InteractionTypesPage,
    InteractionPage,
  ],
    imports: [
        CoreModule,
        CrossModule,
        TableModule,
        DataViewModule,
        DsModule,
        CarouselModule,
        BrowserModule,
        ProgressSpinnerModule,
        ConfirmDialogModule,
    ]
})
export class CiModule { }
